/* osomni-atc.js — v2026-05-03d
 * Custom Add-to-Cart handlers for all custom surfaces (top-picks, collection cards,
 * PDP recommendations, cart-drawer recs). Lives as an external asset so it survives
 * theme apps that strip inline <script> blocks for anonymous visitors.
 *
 * v2026-05-03c: header is inside a JSON section group, so section rendering
 * returns null for individual section IDs. Falls back to fetching the page HTML
 * and extracting the cart drawer + cart icon from it.
 */
(function () {
  if (window._osomniAtcInit) return;
  window._osomniAtcInit = true;

  function applyDrawerFromDoc(doc) {
    var newDialog = doc.querySelector('cart-drawer-component .cart-drawer__dialog');
    var existingDialog = document.querySelector('cart-drawer-component .cart-drawer__dialog');
    if (newDialog && existingDialog) {
      existingDialog.className = newDialog.className;
      var aria = newDialog.getAttribute('aria-labelledby');
      if (aria) existingDialog.setAttribute('aria-labelledby', aria);
      existingDialog.innerHTML = newDialog.innerHTML;
    }
    var newBubble = doc.querySelector('[ref="cartItemCount"]');
    if (newBubble) {
      var newCount = parseInt(newBubble.textContent || '0', 10) || 0;
      document.querySelectorAll('cart-icon').forEach(function (ci) {
        var countEl = ci.querySelector('[ref="cartBubbleCount"]');
        var bubble = ci.querySelector('[ref="cartBubble"]');
        if (countEl) countEl.textContent = newCount < 100 ? String(newCount) : '';
        if (bubble) bubble.classList.toggle('visually-hidden', newCount === 0);
        ci.classList.toggle('header-actions__cart-icon--has-cart', newCount > 0);
        if (countEl) countEl.classList.toggle('hidden', newCount === 0);
      });
    }
    return !!(newDialog && existingDialog);
  }

  function updateCartIconCount(itemCount) {
    document.querySelectorAll('cart-icon').forEach(function (ci) {
      var countEl = ci.querySelector('[ref="cartBubbleCount"]');
      var bubble = ci.querySelector('[ref="cartBubble"]');
      if (countEl) countEl.textContent = itemCount < 100 ? String(itemCount) : '';
      if (bubble) bubble.classList.toggle('visually-hidden', itemCount === 0);
      ci.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
      if (countEl) countEl.classList.toggle('hidden', itemCount === 0);
    });
  }

  /* ─── Helper: replace cart drawer + icon from response.sections, with page-fetch fallback */
  window.osomniSyncCartDrawer = async function (sections) {
    // Try sections data first (fast path; works when section is at template/layout root)
    if (sections) {
      for (var sId in sections) {
        if (!Object.prototype.hasOwnProperty.call(sections, sId)) continue;
        var html = sections[sId];
        if (!html) continue; // null = section is in a section group, fall through
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (applyDrawerFromDoc(doc)) return true;
      }
    }
    // Fallback: fetch the current page with a cache-busting query so we get
    // origin-rendered HTML (which reflects the updated cart cookie), bypassing
    // the stale edge cache.
    try {
      var sep = window.location.search ? '&' : '?';
      var bustUrl =
        window.location.pathname + window.location.search + sep + '_atccb=' + Date.now();
      var pageRes = await fetch(bustUrl, {
        headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!pageRes.ok) return false;
      var pageHtml = await pageRes.text();
      var pageDoc = new DOMParser().parseFromString(pageHtml, 'text/html');
      return applyDrawerFromDoc(pageDoc);
    } catch (e) {
      console.error('[osomni-atc] Page-fetch fallback for drawer sync failed:', e);
      return false;
    }
  };

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      if (c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) === -1) {
        ids.push(c.dataset.sectionId);
      }
    });
    return ids;
  }

  async function performAtc(variantId, quantity) {
    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity || 1));
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });
    if (!res.ok) {
      var errText = await res.text();
      throw new Error('cart/add ' + res.status + ': ' + errText);
    }
    return res.json();
  }

  function dispatchCartUpdate(data, source, variantId) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            sections: data.sections,
            source: source,
            variantId: variantId
          }
        }
      })
    );
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  async function runAtcFlow(btn, source, opts) {
    opts = opts || {};
    if (btn.disabled) return;
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) {
      console.error('[osomni-atc] ' + source + ': missing variantId', btn);
      return;
    }

    var orig = btn.textContent;
    var pendingText = opts.pendingText != null ? opts.pendingText : 'Adding…';
    var doneText = opts.doneText != null ? opts.doneText : '✓ Added';
    btn.textContent = pendingText;
    btn.disabled = true;

    try {
      var data = await performAtc(variantId, 1);
      await window.osomniSyncCartDrawer(data.sections);
      dispatchCartUpdate(data, source, variantId);
      if (opts.openDrawer !== false) openCartDrawer();
      btn.textContent = doneText;
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, opts.resetMs || 2000);
    } catch (err) {
      console.error('[osomni-atc] ' + source + ' failed:', err);
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  /* ─── Card click → PDP (for product-card components that lack a working link) */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('product-card[data-pdp-url]');
    if (!card) return;
    if (e.target.closest('.js-open-product')) return;
    if (e.target.closest('.card-atc-btn')) return;
    if (e.target.closest('.top-picks__atc')) return;
    sessionStorage.setItem('gallery_url', window.location.pathname + window.location.search);
    window.location.href = card.dataset.pdpUrl;
  });

  /* ─── Top Picks (Most Loved on collection page) ─────────────────────────── */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.top-picks__atc');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      runAtcFlow(btn, 'top-picks');
    },
    true
  );

  /* ─── Collection card ATC (.card-atc-btn outside product-recommendations) ─ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-atc-btn');
    if (!btn) return;
    if (btn.closest('.product-recommendations')) return; // handled separately
    runAtcFlow(btn, 'collection-card');
  });

  /* ─── PDP recommendations (.product-recommendations .card-atc-btn) ──────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-recommendations .card-atc-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    runAtcFlow(btn, 'pdp-recommendations');
  });

  /* ─── Cart drawer "+" recs (.cart-rec-item__btn) ────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-rec-item__btn');
    if (!btn) return;
    runAtcFlow(btn, 'cart-rec', {
      pendingText: '✓',
      doneText: '✓',
      openDrawer: false
    });
  });

  /* ─── Homepage "The Collection" carousel ATC (.style-card__atc) ─────────── */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.style-card__atc');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      runAtcFlow(btn, 'pick-your-style');
    },
    true
  );

  /* ─── Homepage "The Collection" carousel scroll-progress bar ────────────── */
  function initPickStyleProgress() {
    var grid = document.querySelector('.pick-style-section .pick-style-grid');
    var prog = document.querySelector('.pick-style-section .pick-style-progress');
    if (!grid || !prog) return;
    var bar = prog.querySelector('.pick-style-progress__bar');
    if (!bar) return;
    function update() {
      var max = grid.scrollWidth - grid.clientWidth;
      if (max <= 1) {
        prog.style.visibility = 'hidden';
        return;
      }
      prog.style.visibility = 'visible';
      var trackW = prog.clientWidth;
      var barW = Math.max((grid.clientWidth / grid.scrollWidth) * trackW, 28);
      bar.style.width = barW + 'px';
      var ratio = grid.scrollLeft / max;
      bar.style.transform = 'translateX(' + ratio * (trackW - barW) + 'px)';
    }
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  if (document.readyState !== 'loading') initPickStyleProgress();
  else document.addEventListener('DOMContentLoaded', initPickStyleProgress);

  /* ─── Homepage "The Collection" desktop carousel arrows ─────────────────── */
  function initPickStyleCarousel() {
    var wrap = document.querySelector('.pick-style-section .pick-style-carousel-wrap');
    if (!wrap) return;
    var grid = wrap.querySelector('.pick-style-grid');
    var prev = wrap.querySelector('.pick-carousel-btn--prev');
    var next = wrap.querySelector('.pick-carousel-btn--next');
    if (!grid || !prev || !next) return;

    function cardStep() {
      var card = grid.querySelector('.style-card');
      if (!card) return grid.clientWidth;
      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var max = grid.scrollWidth - grid.clientWidth;
      if (max <= 2) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      var EDGE = 4; /* tolerance for sub-pixel + snap rounding */
      prev.hidden = grid.scrollLeft <= EDGE;
      next.hidden = grid.scrollLeft >= max - EDGE;
    }

    function scheduleSettle() {
      /* smooth-scroll animation can take ~300-600ms; re-check after it settles */
      setTimeout(updateArrows, 350);
      setTimeout(updateArrows, 700);
    }

    prev.addEventListener('click', function (e) {
      e.preventDefault();
      grid.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      scheduleSettle();
    });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      grid.scrollBy({ left: cardStep(), behavior: 'smooth' });
      scheduleSettle();
    });

    grid.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }
  if (document.readyState !== 'loading') initPickStyleCarousel();
  else document.addEventListener('DOMContentLoaded', initPickStyleCarousel);
})();
